module.exports = __webpack_public_path__ + "img/lightmode_trueuv.457abf4f.png";